import styled from 'styled-components';

export const StyledGraph = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${({ $embedded }) => ($embedded ? 'transparent' : 'var(--white)')};
  border-radius: ${({ $embedded }) => ($embedded ? '0' : '16px')};
  position: relative;
  padding: ${({ $embedded }) => ($embedded ? '0' : '15px 15px 0')};

  @media (min-width: 1440px) {
    padding: ${({ $embedded }) => ($embedded ? '0' : '20px 20px 0')};
  }

  .label {
    width: 100%;
    position: relative;
    bottom: 45px;
    left: 0;
    display: flex;
    justify-content: space-between;
    overflow-x: auto;
    padding-bottom: 10px;
    gap: 23px;
    font-size: 14px;
    line-height: 18px;

    @media (min-width: 768px) {
      left: 60px;
      width: 90%;
      gap: 6px;
      padding-bottom: 0;
      left: 60px;
    }
  }

  .my-custom-chart {
    display: flex;
    flex-grow: 1;
    width: 100%;

    div {
      flex-grow: 1 !important;
    }
  }

  .highcharts-container {
    position: relative;
    width: 100% !important;
    /* height: 260px !important; */
    /* background: rgba(190, 190, 190, 0.1); */

    /* @media (min-width: 1200px) {
      height: 300px !important;
    }
    @media (min-width: 1440px) {
      height: 410px !important;
    }

    @media (min-width: 1550px), (min-height: 1100px) {
      height: 440px !important;
    } */

    &:before {
      display: none;
      content: '';
      position: absolute;
      inset: 0;
      background: rgba(190, 190, 190, 0.1);
    }
  }

  .highcharts-background {
    fill: transparent !important;
  }

  /* .highcharts-title, */
  .highcharts-credits,
  .highcharts-axis,
  /* .highcharts-xaxis-labels, */
  .highcharts-subtitle,
  .highcharts-yaxis,
  .highcharts-no-tooltip {
    display: none;
  }
  .no-data {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }
`;
export const GraphHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  position: relative;
  margin: 0 0 8px;

  @media (min-width: 1440px) {
    margin-bottom: 20px;
  }

  .title,
  .leads,
  .value,
  .analytics-heading {
    display: block;
    color: var(--text-color-50);
  }

  .title,
  .analytics-heading {
    margin: 0 0 12px;
  }

  .leads {
    font-size: 25px;
    line-height: 29px;
  }

  .analytics-heading {
    font-size: 18px;
    line-height: 22px;
    font-weight: 700;
  }

  .dashboard-header {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .title-list {
    display: flex;
    display: none;
    align-items: center;
    gap: 20px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    color: #0d141c;

    li {
      position: relative;

      &:first-child {
        &:before {
          display: none;
        }
      }

      &:before {
        content: '';
        position: absolute;
        top: -6px;
        left: -10px;
        width: 1px;
        height: 30px;
        background: rgba(24, 24, 27, 0.1);
      }
    }
  }

  .dropdown-holder {
    position: relative;
    border: 1px solid #eaeaea;
    border-radius: 10px 10px;
    transition: 0.3s;

    &.active {
      border-radius: 10px 10px 0 0;
      .dropdown {
        opacity: 1;
        visibility: visible;
      }
      .icon {
        transform: scale(-1);
      }
    }

    .icon {
      transition: 0.3s;
      transform: scale(1);
    }

    button {
      font-size: 16px;
      line-height: 20px;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 12px 14px;
    }

    span {
      display: block;
    }

    .dropdown {
      position: absolute;
      top: 44px;
      left: -1px;
      right: -1px;
      background: var(--white);
      z-index: 1;
      padding: 0 0 10px 0;
      border: 1px solid #eaeaea;
      border-top: 0;
      border-radius: 0 0 10px 10px;
      opacity: 0;
      visibility: hidden;
      transition: 0.3s;

      span {
        font-size: 14px;
        line-height: 14px;
        padding: 5px 10px;
        cursor: pointer;
        &:hover {
          background: #f3f3f7;
        }
      }
    }
  }

  .value-holder {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 5px;

    .value {
      font-size: 14px;
      line-height: 16px;
      color: #419400;
    }
  }
`;

export const GraphHolder = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0 0 0 8px;

  @media (min-width: 992px) {
    margin: 0 -15px;
    padding: 0;
  }
`;

export const StyledTag = styled.div`
  display: block;
  color: #71717a;
  position: relative;
  font-size: 12px;
  line-height: 15px;
  padding-left: 10px;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 5px;
    height: 5px;
    background: ${({ $tagcolor }) => $tagcolor && $tagcolor};
    border-radius: 50%;
  }
`;
